import FactorySelector from "components/shared/FactorySelector";
import { COMPANIES } from "pages/manage/settings";
import { useContext } from "react";
import { ProductContext } from "./ProductForm";

const CostDefaultSuppliersView = () => {
  const { product, setProduct } = useContext(ProductContext);

  const costSuppliers = product.costSuppliers || [];
  console.log("costSuppliers", costSuppliers);

  function getSupplierId(company) {
    const x = costSuppliers.find((i) => i.company === company);
    if (x) return x.supplierId;
    return null;
  }

  function onChangeSupplier(company, supplierId) {
    if (!supplierId) {
      setProduct((prev) => ({
        ...prev,
        costSuppliers: (prev.costSuppliers || []).filter(
          (i) => i.company !== company,
        ),
      }));
      return;
    }

    setProduct((prev) => {
      const prevCostSuppliers = prev.costSuppliers || [];
      const found = prevCostSuppliers.find((i) => i.company === company);
      if (found) {
        return {
          ...prev,
          costSuppliers: prevCostSuppliers.map((i) =>
            i.company === company ? { ...i, supplierId, useType: "COST" } : i,
          ),
        };
      } else {
        return {
          ...prev,
          costSuppliers: [
            ...prevCostSuppliers,
            { company, supplierId, useType: "COST" },
          ],
        };
      }
    });
  }

  return (
    <div>
      <h6>Default Cost Suppliers</h6>
      <div className="mt-2 opacity-70">
        Choose cost suppliers for each company if you have multiple suppliers
        for one company.
      </div>
      <div className="mt-2 flex space-x-4">
        {COMPANIES.map((company) => (
          <div key={company} className="flex items-center space-x-3">
            <label>{company}: </label>
            <div className="flex-1">
              <FactorySelector
                value={getSupplierId(company)}
                onChange={(supplierId) => {
                  onChangeSupplier(company, supplierId);
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CostDefaultSuppliersView;
